import styled from "styled-components";

interface IconLoaderStyledProps {
  isDragActive: boolean;
}

export const IconUpdateBodyStyled = styled.div<IconLoaderStyledProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 15px;
  margin-bottom: 16px;
  height: 68px;
  background: #f4f4f4;
  border: ${(props) => (props.isDragActive ? "3px dashed #3f7f7d" : "none")};
`;

export const FilePreviewStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80px;
  height: 68px;
  border-right: 1px solid #e9e9e9;
`;

export const ImageStyled = styled.img`
  width: 50px;
`;

export const FileInfoStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 361px;
`;

export const FileNameStyled = styled.div`
  color: #1b1b1b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const FileWeightStyled = styled.div`
  font-weight: 300;
  font-size: 14px;
  color: #606060;
`;

export const GroupButtonsStyled = styled.div`
  display: flex;
  gap: 8px;
`;

export const ButtonStyled = styled.div`
  height: 20px;
  width: 20px;
  cursor: pointer;
`;

export const FileInputStyled = styled.input`
  opacity: 0;
  height: 0;
  width: 0;
  line-height: 0;
  overflow: hidden;
  padding: 0;
  margin: 0;
`;
